//bao migrate skip
import "./../bindings/bao-searcher";
import * as ko from "knockout";
import Bao from "./../services/bao-service";
import BaoDialog from "./bao-dialog";
class ReminderTicketSendMailDialog {
    ConfigurationItemId = ko.observable("");
    Email = ko.observable<string>();
    Parent = ko.observable<any>();
    constructor(parent: any) {
        this.Parent = parent;
    }
    ItemCompleteCheck(): boolean {
        return true;
    }
    DialogWidth: number = 650;
    DialogHeight: number = 650;
    Dialog(): JQueryPromise<void> {
        return Bao.post("ReminderTicket/ReminderTicketSendMailDialog", JSON.stringify({}), (result) => {
            var dialog = new BaoDialog(Bao.Session.ApplicationName);
            dialog.ViewModel(this);
            var okButton = new BaoDialog.ButtonFactory(dialog, Bao.Session.GetMessage("msgOk"), () => {
                if (this.ItemCompleteCheck()) {
                    this.SendPdfMail(this.ConfigurationItemId());
                    dialog.Close();
                }
            });
            var cancelButton = new BaoDialog.ButtonFactory(dialog, Bao.Session.GetMessage("msgCancel"), () => {
                dialog.Close();
            });
            if (this.DialogWidth != null) {
                dialog.Width(this.DialogWidth + "px");
            }
            dialog.Buttons([okButton, cancelButton]);
            dialog.Template(result.Template);
            dialog.Open(null);
            ko.unwrap(this.Parent).TabPage.IsLoading(false);
        });
    }
    SendPdfMail(userId: string) {
        ko.unwrap(this.Parent).TabPage.IsLoading(true);
        return Bao.post("SynosetReportCenter/GenerateReminderTicketReport", JSON.stringify({
            ticketId: ko.unwrap(this.Parent).TicketId(),
            reportTemplateId: null
        })).then((result) => {
            if (result.isCreated == true) {
                Bao.post("SynosetReportCenter/SendReminderTicketReportPerMail", JSON.stringify({
                    ticketId: ko.unwrap(this.Parent).TicketId(),
                    tempDocId: result.message,
                    emailAddress: this.Email()
                }), (result) => {
                    new BaoDialog(Bao.Session.ApplicationName, result.Message, "info");
                    ko.unwrap(this.Parent).TabPage.IsLoading(false);
                });
            }
            else if (result.isCreated == false) {
                ko.unwrap(this.Parent).TabPage.IsLoading(false);
                new BaoDialog(Bao.Session.ApplicationName, result.message, "info");
            }
        });
    }
}
export default ReminderTicketSendMailDialog;